import { AI_RECOMPOSE_MODE, type AiRecomposeMode } from '../generation';

export const LONG_FORM_GUIDANCE_TYPE = {
  shorten: 'shorten',
  expand: 'expand',
  strict: 'strict',
  creative: 'creative',
  manualRewrite: 'manualRewrite',
  continueWriting: 'continueWriting',
};
export type LongFormGuidanceType =
  (typeof LONG_FORM_GUIDANCE_TYPE)[keyof typeof LONG_FORM_GUIDANCE_TYPE];

const LONG_FORM_GUIDANCE_TYPE_TO_GENERATION_GUIDANCE_TYPE: Record<
  LongFormGuidanceType,
  AiRecomposeMode
> = {
  [LONG_FORM_GUIDANCE_TYPE.shorten]: AI_RECOMPOSE_MODE.shorten,
  [LONG_FORM_GUIDANCE_TYPE.expand]: AI_RECOMPOSE_MODE.expand,
  [LONG_FORM_GUIDANCE_TYPE.strict]: AI_RECOMPOSE_MODE.strict,
  [LONG_FORM_GUIDANCE_TYPE.creative]: AI_RECOMPOSE_MODE.refine,
  [LONG_FORM_GUIDANCE_TYPE.manualRewrite]: AI_RECOMPOSE_MODE.instructionBased,
};
export const longFormGuidanceTypeToRecomposeMode = (type: LongFormGuidanceType): AiRecomposeMode =>
  LONG_FORM_GUIDANCE_TYPE_TO_GENERATION_GUIDANCE_TYPE[type];
